<template>
	<div>
		<q-btn v-if="!confirming" class="gt-xs" @click="onStartClicked()" :disabled="isDisabled" :flat="isFlat" :color="color || 'red'" size="18px" dense round :icon="icon" >
		</q-btn>
		<q-btn v-if="confirming && iconConfirm" class="gt-xs" @click="onConfirmedClicked()" :flat="isFlat" :color="confirmColor || color || 'red'" size="18px" dense round :icon="iconConfirm" >
		</q-btn>
		<q-tooltip v-if="tooltipTitle" class="sci-fi-tooltip" :delay="500">
			<div class="tooltip-title">{{ tooltipTitle }}</div>
			<div v-if="tooltipDesc" class="tooltip-desc">{{ tooltipDesc }}</div>
		</q-tooltip>
	</div>
</template>

<script setup lang="ts">

interface Props {
  item: Object,
  action: (item?: any) => void,
  icon: string,
  iconConfirm?: string,
  color?: string,
  confirmColor?: string,
  isFlat?: boolean
  isDisabled?: boolean
  tooltipTitle?: string
  tooltipDesc?: string
};

	const props = defineProps<Props>();
	const confirming = ref(false);

	const onStartClicked = () => {
		if(!props.iconConfirm) {
			confirming.value = false;
			props.action(props.item);
		} else {
			confirming.value = true;
			setTimeout(() => {
				confirming.value = false;
			}, 2000);
		}
	}

	const onConfirmedClicked = () => {
		props.action(props.item);
	}
</script>